import React, { Fragment, useContext, useEffect, useState } from 'react';

import { AnimatePresence, motion } from 'framer-motion';
import { ThemeContext } from 'styled-components';

import YatTextReveal from '@pkg/components/Sections/Profile/TextReveal';
import { publish } from '@pkg/components/Sections/Profile/pubSub';
import { glPauseAnimation } from '@pkg/components/Sections/Profile/pubSub/constants';
import { useAppSelector } from '@pkg/hooks';
import { useGetPortfolioLidTokensData } from '@pkg/hooks/liquid-id';
import { useMediaQuery } from '@pkg/providers';

import { CollectionLink } from '@app/pages/Collection/components/CollectionLink';

import TickerTitle from './TickerTitle';

import {
    CollectionName,
    ExpandedLiquidIDItemDetailsWrapper,
    ItemDetails,
    StyledLiquidIDThumbnails,
    StyledTitle,
} from './styles';

interface Props {
    expanded?: boolean;
}

const LiquidIDItemDetails = ({ expanded = true }: Props) => {
    const { data: liquidIDItems } = useGetPortfolioLidTokensData();
    const liquidIDExpandedPreview = useAppSelector((state) => state.yatPage.liquidIDExpandedPreview);
    const managerPanelOpen = useAppSelector((state) => state.nftManager.managerPanelOpen);

    const [currentFaceIndex, setCurrentFaceIndex] = useState<number>(0);
    const { transitions } = useContext(ThemeContext);
    const { desktop } = useMediaQuery();

    useEffect(() => {
        if (expanded) publish(glPauseAnimation);
    }, [expanded]);

    const currentFace = currentFaceIndex !== undefined ? liquidIDItems?.[currentFaceIndex] : undefined;
    const currentFaceTitle = currentFace?.name;

    return (
        <AnimatePresence mode="wait">
            {expanded && !managerPanelOpen && (
                <ExpandedLiquidIDItemDetailsWrapper
                    key={'expanded'}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                        duration: transitions.speeds.normal,
                        delay: transitions.speeds.normal,
                        ease: transitions.eases.cubic,
                    }}
                    $preview={liquidIDExpandedPreview}
                >
                    <ItemDetails>
                        <StyledTitle type="headline" size={91}>
                            {currentFaceTitle && (
                                <Fragment key={currentFaceTitle}>
                                    {desktop && currentFaceTitle.length > 15 ? (
                                        <TickerTitle key={currentFaceTitle} title={currentFaceTitle} />
                                    ) : (
                                        <YatTextReveal key={currentFaceTitle} text={currentFaceTitle} />
                                    )}
                                </Fragment>
                            )}
                        </StyledTitle>
                        <AnimatePresence>
                            <motion.div
                                key={currentFace?.name}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{
                                    duration: transitions.speeds.fast,
                                    delay: transitions.speeds.fast * 2,
                                    ease: transitions.eases.cubic,
                                }}
                            >
                                <CollectionLink slug={currentFace?.slug}>
                                    <CollectionName $expanded>
                                        {/*TODO: Add verified and collection name*/}
                                        {/*{currentFace?.verified && <StyledVerificationIcon />}*/}
                                        {/*<StyledCollectionTypography type="label" size={18} weight="400">*/}
                                        {/*    {currentFace?.collectionName}*/}
                                        {/*</StyledCollectionTypography>*/}
                                    </CollectionName>
                                </CollectionLink>
                            </motion.div>
                        </AnimatePresence>
                    </ItemDetails>
                    {liquidIDExpandedPreview && (
                        <StyledLiquidIDThumbnails
                            liquidIDFaceSelection={currentFaceIndex}
                            onClick={(index) => setCurrentFaceIndex(index)}
                        />
                    )}
                </ExpandedLiquidIDItemDetailsWrapper>
            )}
        </AnimatePresence>
    );
};

export default LiquidIDItemDetails;
